module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-movie-all-years.97a01b31.svg";